module.exports = __webpack_public_path__ + "static/media/homePage_iot.dbd189b3.jpg";